module.exports = __webpack_public_path__ + "img/nrm-logo.9c7ce620.png";